export class AdditionalElementsForPrescriptionReleaseFormSearchRequest {
    public searchText: string;
    public listIdElementsMandatoryToGet: number[] = [];
}